import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import EllipsesControl from '../../../Common/EllipsesControl/EllipsesControl';
import {
	employmentStatusTypes,
	employmentStatuses,
	labels
} from '../../../../util/uiconstants';
import {clearErrors} from '../../../../actions/erroractions';
import {setIsModalOpen} from '../../../../actions/modalstateactions';
import {getEmployeeADStatus} from '../../../../actions/admin/engagement/engagementActions';
import MotifTooltip from '@ey/motif-react-wrapper/Tooltip';
import {MotifIcon, MotifIconButton} from '@ey-xd/motif-react';
import {IconoirTrash} from '@ey-xd/motif-icon';

function PermissionGroupUserRow(props) {
	const dispatch = useDispatch();

	const defaultStatus = {key: employmentStatusTypes.DefaultStatus, text: '...'};
	const onErrorStatus = {
		key: employmentStatusTypes.InActive,
		text: labels.inactive
	};

	const employeeADStatuses = useSelector((store) => store.employeeADStatuses);
	const [employeeADStatus, setEmployeeADStatus] = useState(defaultStatus);

	//Microsoft graph call to get AD status
	useEffect(() => {
		dispatch(getEmployeeADStatus(props.data?.emailAddress)).catch(() => {
			setEmployeeADStatus(onErrorStatus);
			clearError(true);
		});
	}, []);

	// Load AD status in the UI
	useEffect(() => {
		const filteredStatus = employeeADStatuses[props.data.emailAddress];
		if (
			employmentStatuses.includes(filteredStatus) &&
			employeeADStatus.key !== employmentStatusTypes.Active
		) {
			setEmployeeADStatus({
				key: employmentStatusTypes.Active,
				text: labels.active
			});
		}
	}, [employeeADStatuses[props.data.emailAddress]]);

	const clearError = (isModelOpen) => {
		dispatch(clearErrors()).then(() => {
			dispatch(setIsModalOpen(isModelOpen));
		});
	};

	return (
		<section className="permissionitemview">
			<section className="userlistitem grid">
				<section className="description">
					<section className="detail motif-body2-default-light">
						<EllipsesControl
							content={props.data.firstName}
							tooltip={props.data.firstName}
							displayId={''}
							noOfLines={1}
							ellipsisClass="columnName"
						/>
					</section>
				</section>
			</section>
			<section className="userlistitem grid">
				<section className="description">
					<section className="detail motif-body2-default-light">
						<EllipsesControl
							content={props.data.lastName}
							tooltip={props.data.lastName}
							displayId={''}
							noOfLines={1}
							ellipsisClass="columnName"
						/>
					</section>
				</section>
			</section>
			<section className="userlistitem grid title">
				<section className="description">
					<section className="detail motif-body2-default-light">
						<EllipsesControl
							content={props.data.title}
							tooltip={props.data.title}
							displayId={''}
							noOfLines={1}
							ellipsisClass="columnName"
						/>
					</section>
				</section>
			</section>
			<section className="userlistitem grid email">
				<section className="description">
					<section className="detail motif-body2-default-light">
						<EllipsesControl
							content={props.data.emailAddress}
							tooltip={props.data.emailAddress}
							displayId={''}
							noOfLines={1}
							ellipsisClass="columnName"
						/>
					</section>
				</section>
			</section>
			<section className="userlistitem grid gui">
				<section className="description">
					<section className="detail motif-body2-default-light">
						<EllipsesControl
							content={props.data.gui}
							tooltip={props.data.gui}
							displayId={''}
							noOfLines={1}
							ellipsisClass="columnName"
						/>
					</section>
				</section>
			</section>
			<section className="userlistitem grid userid">
				<section className="description">
					<section className="detail motif-body2-default-light">
						<EllipsesControl
							content={props.data.userID}
							tooltip={props.data.userID}
							displayId={''}
							noOfLines={1}
							ellipsisClass="columnName"
						/>
					</section>
				</section>
			</section>
			<section className="userlistitem grid status">
				<section className="description">
					<section className="detail">
						<EllipsesControl
							content={employeeADStatus?.text}
							tooltip={employeeADStatus?.text}
							displayId={''}
							noOfLines={1}
							ellipsisClass="columnName"
						/>
					</section>
				</section>
			</section>
			<section className="userlistitem grid delete">
				<section className="description">
					<section className="detail editicon-button">
						<MotifTooltip
							flip={false}
							id={'deleteButtonTooltipId'}
							placement={'left'}
							hideCloseButton
							contentClassName="delete"
							hide={props.permissions.canCreateUpdatePermissionsGroups}
							trigger={
								<section>
									<MotifIconButton
										aria-label="delete-icon"
										disabled={
											!props.permissions.canCreateUpdatePermissionsGroups
										}
										onClick={() => props.onDeleteClick(props.data)}
										className="edit-user-edit-btn"
									>
										<MotifIcon
											name="delete"
											className="deleteicon"
											iconFunction={IconoirTrash}
											title={labels.permissionGroupUserDeleteLabel}
											size={24}
										/>
									</MotifIconButton>
								</section>
							}
						>
							{labels.insufficientPermission}
						</MotifTooltip>
					</section>
				</section>
			</section>
		</section>
	);
}

export default PermissionGroupUserRow;
